import { api } from "@/api/client";

export type CoordinatorUser = {
  id: string;
  inspector: boolean;
};

export type QualifierUser = {
  id: string;
  name: string;
  userName: string;
};

export type UserSignature = {
  userSignatureId: string;
  signature: string;
};

export function getQualifierUserList() {
  return api.get<QualifierUser[]>("user/qualifier");
}

export function getQualifierUser() {
  return api.get<QualifierUser>("user/qualifier/current");
}

export function getCoordinatorUser() {
  return api.get<CoordinatorUser>("user/coordinator/current");
}

export function getUserSignatures() {
  return api.get<UserSignature[]>("user/signatures");
}

export function saveUserSignature(signature: UserSignature) {
  return api.post<UserSignature[]>("user/signatures", signature);
}
